import React, { useEffect, useState } from 'react';

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';

import { ReactComponent as CircleUnchecked } from '../../../../assets/img/check.svg';
import { ReactComponent as CircleChecked } from '../../../../assets/img/checkFilled.svg';
import FloatingButton from '../../../../components/FloatingButton';
import { incidentRoad } from '../../../../constants/incidents.constant';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import SelectTypeOfDamage from './SelectTypeOfDamage.component';
import StolenTires from './StolenTires.component';

const Parts = () => {
  const { nextStep, updateSinisterBody, sinister_body } =
    useSinisterDataContext();
  const { user } = useAuthDataContext();

  let robbery: { [index: string]: any } = incidentRoad.robbery;
  let incidentType = incidentRoad[sinister_body.incident_type];

  const [otherParts, setOtherParts] = useState(
    sinister_body?.robbery?.description || ''
  );
  const [tires, setTires] = useState(sinister_body?.robbery?.tire || false);
  const [other, setOther] = useState(sinister_body?.robbery?.other || false);

  const steps = {
    tires: [
      {
        title: 'Neumáticos robados',
        content: <StolenTires />,
        order:
          sinister_body?.robbery?.type === 'total'
            ? 8
            : sinister_body?.incident_type === 'damage'
            ? 7
            : 6,
      },
      {
        title: 'Daños en mi vehículo',
        content: <SelectTypeOfDamage />,
        order:
          sinister_body?.robbery?.type === 'total'
            ? 9
            : sinister_body?.incident_type === 'damage'
            ? 8
            : 7,
      },
    ],
    other: [
      {
        title: 'Daños en mi vehículo',
        content: <SelectTypeOfDamage />,
        order:
          sinister_body?.robbery?.type === 'total'
            ? 9
            : sinister_body?.incident_type === 'damage'
            ? 8
            : 7,
      },
    ],
  };

  useEffect(() => {
    //TODO: fix this bad assignation
    robbery = incidentRoad.robbery;
    incidentType = incidentRoad[sinister_body.incident_type];

    incidentType.forEach((element: any, key: any) => {
      if (element.title === 'Neumáticos robados') {
        incidentType.splice(key, 1);
      }

      if (element.title === 'Daños en mi vehículo') {
        incidentType.splice(key, 1);
      }
    });

    incidentType = incidentType.sort((a: any, b: any) =>
      a.order > b.order ? 1 : -1
    );
  }, []);

  const handleNextStep = () => {
    let optionsSelected = [];
    let keytodelete = null;
    incidentType = incidentRoad[sinister_body.incident_type];

    updateSinisterBody({
      robbery: {
        ...sinister_body.robbery,
        tire: tires,
        other: other,
        description: otherParts,
      },
    });

    if (tires === true) {
      optionsSelected.push('Neumaticos');
    }

    if (other === true) {
      optionsSelected.push('Otras partes');
    }

    dataLayerPush('siniestro_OD_que_robo', user?.id, {
      fieldName: 'opcion_siniestro_conductor',
      fieldValue: optionsSelected,
    });

    if (tires === true) {
      if (
        !incidentType.find(
          (element: { title: any }) => element.title === 'Neumáticos robados'
        )
      ) {
        sinister_body.incident_type === 'damage'
          ? incidentType.push(steps.tires[0])
          : steps.tires.forEach((step) => {
              incidentType.push(step);
            });
      }
    }

    if (other === true && sinister_body.incident_type !== 'damage') {
      if (
        !incidentType.find(
          (element: { title: any }) => element.title === 'Daños en mi vehículo'
        )
      ) {
        steps.other.forEach((step) => {
          incidentType.push(step);
        });
      } else {
        incidentType.forEach((element: any, key: any) => {
          if (element.title === 'Daños a mi vehículo') {
            incidentType.splice(key, 1);
          }
        });
      }
    }

    if (keytodelete) robbery.splice(keytodelete, 1);

    incidentType = incidentType.sort((a: any, b: any) =>
      a.order > b.order ? 1 : -1
    );
    nextStep();
  };

  return (
    <>
      <Grid item xs={12} sm={6}>
        <Box>
          <Box my={4}>
            <Typography variant="h6" color="textPrimary">
              ¿Qué te robaron?
            </Typography>
          </Box>

          <Grid container item lg={12}>
            <Box mr={2} my={2}>
              <FormControl component="fieldset">
                <FormGroup aria-label="position">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={tires}
                        name="tires"
                        icon={<CircleUnchecked />}
                        checkedIcon={<CircleChecked />}
                        onChange={(event) => setTires(event.target.checked)}
                      />
                    }
                    label="Neumáticos"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={other}
                        name="other"
                        icon={<CircleUnchecked />}
                        checkedIcon={<CircleChecked />}
                        onChange={(event) => setOther(event.target.checked)}
                      />
                    }
                    label="Otras partes"
                  />
                </FormGroup>
              </FormControl>
            </Box>
          </Grid>
        </Box>
      </Grid>
      {other && (
        <Grid container>
          <Grid item xs={12}>
            <Box my={2}>
              <TextField
                size="small"
                multiline
                rows={5}
                name="origin"
                fullWidth={true}
                id="origin"
                placeholder="Me abrieron el vehículo y me robaron ..."
                variant="outlined"
                onChange={(event: any) => setOtherParts(event.target.value)}
                value={otherParts}
                error={otherParts.length > 1333}
                helperText={
                  otherParts.length > 1333 &&
                  'La descripción no debería superar los 1333 caracteres'
                }
              />
            </Box>
          </Grid>
        </Grid>
      )}
      <Grid>
        <Grid container justify="center">
          <Grid item xs={12} sm={6}>
            <FloatingButton
              onClick={handleNextStep}
              disabled={other ? !otherParts : !other && !tires}
            >
              Continuar
            </FloatingButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Parts;
